// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineMessage_diet_container__2Fq22","header":"OfflineMessage_diet_header__1k_DV"};